exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field-row[data-v-8bd1f248]{margin-left:-100px}.field-row .field[data-v-8bd1f248]{margin-left:100px}", ""]);

// exports
